import {
  Card,
  CardContent,
  CardHeader,
  Skeleton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@schaeffler-commerce/design-system";
import { ButtonSkeleton } from "~/common/components/CommonSkeletons";
import { Pagination } from "~/features/cms/homepagePersonalization/components/loadingSkeleton/PaginationSkeleton";

export default function TableSkeleton() {
  const singleCellSkeleton = (key: number, width: number = 100) => (
    <TableCell key={key}>
      <Skeleton width={width} height={16} />
    </TableCell>
  );
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="titleLarge">
            <Skeleton width={200} />
          </Typography>
        }
        action={<ButtonSkeleton width={76} />}
      />
      <CardContent component={Stack} sx={{ gap: 1 }}>
        <Table>
          <TableHead>
            <TableRow>{[...Array(4)].map((e, i) => singleCellSkeleton(i, 80))}</TableRow>
          </TableHead>
          <TableBody>
            {[...Array(5)].map((e, i) => (
              <TableRow key={i}>{[...Array(4)].map((e, i) => singleCellSkeleton(i, 100))}</TableRow>
            ))}
            <TableRow>
              <TableCell />
              <TableCell />
              <TableCell />
              <TableCell />
            </TableRow>
          </TableBody>
        </Table>
        <PaginationView>
          <Pagination />
        </PaginationView>
      </CardContent>
    </Card>
  );
}

const PaginationView = styled("div")({
  display: "flex",
  justifyContent: "center",
});
